var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_vm._v(" Fund Overview "),_c('div',[_c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"items":_vm.desserts}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }